import { render, staticRenderFns } from "./_Delete.vue?vue&type=template&id=0da12ff8"
import script from "./_Delete.vue?vue&type=script&lang=js"
export * from "./_Delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports